// The platform's transport for additional attributes (packages/page-runtime/
// src/uda): the /api/uda/{project}/* endpoints, bound to one project. Who may
// set them up and where they are stored (the caller's tenant) is the server's
// decision. Wired into the screen runtime in Phase 4.

import type { UdaTransport } from '@twasta/page-runtime/uda'
import {
  udaCanSetup, udaCatalogColumns, udaCatalogTables, udaCheckCode, udaCoverage, udaExport,
  udaGet, udaHistory, udaImport, udaMasterValues, udaPatchDraft, udaPreview, udaPublish,
  udaRollback, udaGetCode, udaSaveCode,
} from '@/api/uda'

export function platformUdaTransport(project: string): UdaTransport {
  return {
    canSetup: (objName) => udaCanSetup(project, objName),
    get: (objName) => udaGet(project, objName),
    patchDraft: (objName, body, baseVersion) => udaPatchDraft(project, objName, body, baseVersion),
    masterValues: (objName, formNo, via, column, opts) =>
      udaMasterValues(project, objName, formNo, via, column, opts),
    coverage: (objName, req) => udaCoverage(project, objName, req),
    preview: (objName, formNo, drivers, body) => udaPreview(project, objName, formNo, drivers, body),
    checkCode: (objName, fnName, source) => udaCheckCode(project, objName, fnName, source),
    getCode: (objName, fnName) => udaGetCode(project, objName, fnName),
    saveCode: (objName, fnName, source) => udaSaveCode(project, objName, fnName, source),
    publish: (objName, baseVersion, summary) => udaPublish(project, objName, baseVersion, summary),
    history: (objName) => udaHistory(project, objName),
    rollback: (objName, version) => udaRollback(project, objName, version),
    importRules: (objName, formNo, input) => udaImport(project, objName, formNo, input),
    exportRules: (objName, formNo) => udaExport(project, objName, formNo),
    catalogTables: (objName) => udaCatalogTables(project, objName),
    catalogColumns: (objName, table) => udaCatalogColumns(project, objName, table),
  }
}
